import PDF from './pdf'
import { capitalizeFirstLetter, getCurrentDateEnUsFormat } from '../lib/utils'

export default class StoreInventoryPdf extends PDF {
  /**
   * Description
   * @param {import('jspdf').DocumentProperties} args
   */
  constructor(args = {}) {
    super()
    this.doc.setProperties({
      unit: 'mm',
      format: 'a4',
      ...args,
    })
    this.addFonts()
  }

  /**
   * Description
   * @param {boolean} [cancel]
   */
  __header() {
    const title = `${capitalizeFirstLetter(this.getStoreName())} Report`
    this.generateText({ fontSize: 24, text: title, coordinates: [65, 15], color: [55, 71, 79] })
    this.generateText({ fontSize: 12, text: getCurrentDateEnUsFormat(), coordinates: [100, 22] })
    this.doc.setFillColor('#CFD8DC')
    this.doc.line(15, 25, 195, 25, 'F')
  }

  __subHeader() {
    const [x, y] = [15, 40]
    const delimiter = ':'
    const date = getCurrentDateEnUsFormat()
    this.generateField({
      label: 'Date',
      value: date,
      coordinates: [x, y + 10],
      delimiter,
    })
  }

  /**
   * Description
   * @param {{ totalAmount: number; }} params
   * @param {InventoryItem[]} body
   * @returns {any}
   */
  __table(body) {
    this.doc.autoTable({
      head: [
        [
          { content: 'Code', styles: { halign: 'center' } },
          { content: 'Item', styles: { halign: 'center' } },
          { content: 'Brand', styles: { halign: 'center' } },
          { content: 'Qty', styles: { halign: 'center' } },
        ],
      ],
      startY: 40,
      body,
      columnStyles: {
        3: { halign: 'right', cellWidth: 35 },
      },
    })
  }

  /**
   * Description
   * @param {string} orderNo
   * @param {boolean} [cancel]=false
   * @returns {void}
   */
  __save() {
    const storeName = this.getStoreName()
      ?.replace?.(' ', '_')
      ?.toLowerCase?.()
    const name = `${storeName}_inventory_${(new Date()).getTime()}`
    this.doc.save(name)
  }

  /**
   * Description
   * @param {InventoryData} data
   * @param {InventoryItem[]} items
   * @param {boolean} [cancel]
   * @returns {any}
   */
  generate(items) {
    this.__header()
    // this.__subHeader()
    this.__table(items)
    this.__save()
  }
}

/**
 * @typedef InventoryData
 * @property {number} date_range
 * 
 * @typedef {[string, string, string, string, number]} InventoryItem
 * 
 * @type {InventoryItem}
 * @example
 * [Stock Code, item description, brand name, unit, quantity]
 */
